import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setDanceOnAddProcess } from '@state/actions/dances'
import * as Utils from '@services/utils'
import { saveDance } from '@services/dances'
import MessageModal from '@components/Modals/MessageModal'
import SubmitButton from '@components/Buttons/SubmitButton'
import CancelButton from '@components/AddEditDance/CancelButton'
import { useUser } from '@state/uses/users'
import { useSaveFromReAkumSearch } from '@state/uses/dances'
import StatusProgressButton, {
    DANCE_STATUS_ORDERED,
} from '@components/AddEditDance/StatusProgressButton'
import {
    FormRow,
    SubmitWrapper,
    SubmitButtonsRow,
    SubmitBtnContainer,
} from '@appearance/styled'
import i18n from '@localization/i18n'
import urlUtils from '@services/urlUtils'
export const optModalTexts = {
    newDance: {
        title: i18n.t('modals.request_recieved'),
        mainText: i18n.t('modals.request_under_review'),
    },
    editDance: {
        title: i18n.t('modals.dance_updated_successfully'),
        mainText: i18n.t('modals.back_to_dances_screen'),
    },
}

const optErrorModalTexts = {
    'song already exist': 'לא ניתן לשלוח את הבקשה. הריקוד קיים במערכת',
}

export default ({ dance, error }) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const user = useUser()
    const saveFromReAkumSearch = useSaveFromReAkumSearch()

    const modalTexts = dance.id
        ? optModalTexts.editDance
        : optModalTexts.newDance

    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [errorModalIsOpen, setErrorModalIsOpen] = useState(false)
    const [errorMessege, setErrorMessege] = useState('')

    if (!dance) {
        return null
    }

    const formIsValid = () => {
        console.log('formIsValid init - dance', dance)
        if (
            Utils.isEmptyStr(dance.name) ||
            Utils.isEmpty(dance.choreographer) ||
            Utils.isEmptyStr(dance.song.name) ||
            Utils.isEmptyStr(dance.performer) ||
            // Utils.isEmptyStr(dance.song.performer) ||
            (Utils.isEmptyStr(dance.song.akum_id) &&
                !user?.is_admin &&
                (!dance.status || dance.status === DANCE_STATUS_ORDERED)) ||
            (Utils.isEmptyStr(dance.song.composer) &&
                Utils.isEmptyStr(dance.song.composers)) ||
            (Utils.isEmptyStr(dance.song.lyricist) &&
                Utils.isEmptyStr(dance.song.lyricists))
        ) {
            return false
        }

        return true
    }

    const goToDancesScreen = () => {
        setModalIsOpen(false)
        urlUtils.redirectToPreviousUrl()
    }

    const onSubmitCallback = () => {
        dispatch(setDanceOnAddProcess(null))
        setModalIsOpen(true)
    }

    const onSubmitError = (err) => {
        // console.log('akum search err = ', err.split(':')[2].split('"')[1])
        // console.log('akum search err = ', err)
        // setErrorMessege(toString(err).split(':')[2].split('"')[1])
        if (err) {
            const errMsg = err.msg?.error || err.split(':')[2]?.split('"')[1]
            setErrorMessege(errMsg)
        }

        setErrorModalIsOpen(true)
    }

    const submit = () => {
        if (formIsValid()) {
            const newSong = { ...dance.song, name: dance?.song?.name?.trim() }
            const newDance = {
                ...dance,
                name: dance?.name?.trim(),
                song: newSong,
            }
            saveDance(newDance, onSubmitCallback, onSubmitError)
        }
    }

    return (
        <SubmitWrapper>
            <SubmitButtonsRow>
                <SubmitBtnContainer>
                    <SubmitButton
                        onClick={submit}
                        disabled={!formIsValid()}
                        label={
                            dance.id
                                ? i18n.t('edit_dance.save')
                                : i18n.t('edit_dance.send_request')
                        }
                    />
                </SubmitBtnContainer>
                <SubmitBtnContainer>
                    <CancelButton
                        label={
                            dance.id
                                ? i18n.t('edit_dance.cancel_edit')
                                : i18n.t('edit_dance.canael_order')
                        }
                    />
                </SubmitBtnContainer>
                <StatusProgressButton dance={dance} formValid={formIsValid()} />
                <StatusProgressButton
                    dance={dance}
                    formValid={formIsValid()}
                    del
                />
            </SubmitButtonsRow>
            {(!dance.song.akum_id || dance.song.akum_id === '') &&
                (!dance.status || dance.status === DANCE_STATUS_ORDERED) && (
                    <FormRow>
                        <ErrorText>
                            {i18n.t('edit_dance.no_akum_search_error')}
                        </ErrorText>
                    </FormRow>
                )}
            <FormRow>
                <ErrorText>{error}</ErrorText>
            </FormRow>

            <MessageModal
                isOpen={modalIsOpen}
                title={modalTexts.title}
                mainText={modalTexts.mainText}
                onClose={goToDancesScreen}
            />
            <MessageModal
                isOpen={errorModalIsOpen}
                title={i18n.t('modals.error')}
                mainText={optErrorModalTexts[errorMessege]}
                onClose={() => setErrorModalIsOpen(false)}
                error
            />
        </SubmitWrapper>
    )
}

const ErrorText = styled.span`
    color: red;
    text-align: center;
    width: 100%;
`
